import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import TreeListProps from './TreeListProps'
import KendoTreeListColumn from '../KendoTreeListColumn'

import ColumnMenu from './ColumnMenu'
import Editable from './Editable'
import Excel from './Excel'
import Filterable from './Filterable'
import Messages from './Messages'
import Pageable from './Pageable'
import Pdf from './Pdf'
import Sortable from './Sortable'
import Toolbar from './Toolbar'

export default {
    props: TreeListProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        ColumnMenu,
        Editable,
        Excel,
        Filterable,
        Messages,
        Pageable,
        Pdf,
        Sortable,
        Toolbar
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoTreeList(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTreeList()
        },
        _resolveChildren() {
            this.resolveChildren('columns', KendoTreeListColumn.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/KendoTreeListMixin.js